import { DiffusionScreen } from "./diffusion-screen";

/** Screen 019 — "Diffuser vers donneurs d'ordre". */
export function DiffusionDO() {
  return <DiffusionScreen title="Diffuser vers donneurs d'ordre" target="do" />;
}
